(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[552],{

/***/ 4183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(5067);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs
var jsx_runtime = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/about-us/lotte.jpg
/* harmony default export */ var lotte = ({"src":"/_next/static/media/lotte.006ce796.jpg","height":1560,"width":316,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAIDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAcEAABAwUAAAAAAAAAAAAAAAAAAQMVBBEhZeP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AjD0qpeHazqu4AA//2Q==","blurWidth":2,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/about-us/chiara.jpg
/* harmony default export */ var chiara = ({"src":"/_next/static/media/chiara.be7537e3.jpg","height":1558,"width":304,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAIDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAcEAABAwUAAAAAAAAAAAAAAAAAAQIDBCE0ldP/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AsSjtgO1s3UAAf//Z","blurWidth":2,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/about-us/both.jpg
/* harmony default export */ var both = ({"src":"/_next/static/media/both.8ecb850d.jpg","height":1562,"width":296,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAIDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAaEAACAwEBAAAAAAAAAAAAAAAAEQECBFSx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJLYnaVihPhzR7cAAf/Z","blurWidth":2,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/about-us.tsx








const hideMobile = [
    "none",
    null,
    "block"
];
const hideDesktop = [
    "block",
    null,
    "none"
];
// @ts-ignore collections prop used for header
const AboutUs = (param)=>{
    let { collections  } = param;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                title: "ABOUT US - Blickfang"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* HStack */.Ug, {
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Box */.xu, {
                        display: hideMobile,
                        minWidth: "max-content",
                        overflow: "hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            priority: true,
                            quality: 70,
                            alt: "Lotte",
                            src: lotte,
                            placeholder: "blur",
                            width: "200",
                            style: {
                                height: "auto"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Box */.xu, {
                        display: hideDesktop,
                        minWidth: "max-content",
                        overflow: "hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            priority: true,
                            quality: 70,
                            alt: "Both",
                            src: both,
                            placeholder: "blur",
                            width: "140",
                            style: {
                                height: "auto"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* VStack */.gC, {
                            padding: 4,
                            pt: 15,
                            maxWidth: "800px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Heading */.X6, {
                                    pb: 10,
                                    children: "ABOUT US"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(index_esm/* Text */.xv, {
                                    children: [
                                        "Wir sind Chiara und Lotte, Gr\xfcnderinnen von Blickfang.",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        "Unser Modelabel entsandt im Herbst 2020 aus einer spontanen Idee, die mehr als Witz gedacht war. Doch aus einer Mischung aus Corona-Frustration und pl\xf6tzlichem Schaffensdrang, gr\xfcndeten wir mit 18 Jahren unser erstes Unternehmen.",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        "Uns war es wichtig, Produkte zu entwickeln, die dem Zeitgeist unserer Generation entsprechen. So war uns klar, dass graphische Designs und Nachhaltigkeit die Grundpfeiler unseres Unternehmens darstellen werden.",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        "Den Designprozess und das Drucken \xfcbernehmen wir selbst. Am Anfang steht eine Idee, welche wir zu einem fertigen Motiv entwickeln. Dieses bringen wir dann auf die Kleidung. Daf\xfcr haben wir das Verfahren des Siebdrucks gew\xe4hlt, das als eines der nachhaltigsten gilt und drucken seitdem jedes Kleidungsst\xfcck von Hand. Es ist uns wichtig, unser Nachhaltigkeitskonzept stets zu hinterfragen und st\xe4ndig weiterzuentwickeln.",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        "Seit diesem Jahr arbeiten wir daran, unsere Vision von vor 2 Jahren Schritt f\xfcr Schritt zu professionalisieren. Gerade bauen wir unsere eigene kleine Siebdruckwerkstatt in einem r\xfcmpeligen Keller in Potsdam auf.",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("br", {}),
                                        "Wir freuen uns auf alles, was kommt. Seid dabei!"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_esm/* Box */.xu, {
                        display: hideMobile,
                        minWidth: "max-content",
                        overflow: "hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            priority: true,
                            quality: 70,
                            alt: "Chiara",
                            src: chiara,
                            placeholder: "blur",
                            width: "200",
                            style: {
                                height: "auto"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var about_us = (AboutUs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,962,888,179], function() { return __webpack_exec__(4183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);